import { render } from "./AudienceDashboard.vue?vue&type=template&id=59dfcd95&scoped=true"
import script from "./AudienceDashboard.vue?vue&type=script&lang=js"
export * from "./AudienceDashboard.vue?vue&type=script&lang=js"

import "./AudienceDashboard.vue?vue&type=style&index=0&id=59dfcd95&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59dfcd95"]])

export default __exports__